import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'dating',
    component: () => import('../views/Dating.vue'),
    meta: {
      isTabbar: false,
    },
  },
  {
    path: '/announcement',
    name: 'Announcement',
    component: () => import('../views/Announcement/Index.vue'),
    meta: {
      isTabbar: false,
    },
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      isTabbar: true,
    },
  },
  {
    path: '/homerepair',
    name: 'HomeRepair',
    component: () => import('../views/HomeRepair.vue'),
    meta: {
      isTabbar: true,
    },
  },
  {
    path: '/bctime',
    name: 'Bctime',
    component: () => import('../views/Bctime.vue'),
    meta: {
      isTabbar: false,
    },
  },
  {
    path: '/ticket',
    name: 'Ticket',
    component: () => import(/* webpackChunkName: "about" */ '../views/Ticket/index.vue'),
    meta: {
      isTabbar: false,
    },
  },
  {
    path: '/map',
    name: 'Map',
    component: () => import('../views/Map.vue'),
  },
  {
    path: '/maprepair',
    name: 'MapRepair',
    component: () => import('../views/MapRepair.vue'),
  },
  {
    path: '/choose',
    name: 'Choose',
    component: () => import('../views/choose.vue'),
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import('../views/Order.vue'),
  },
	{
	  path: '/repair',
	  name: 'Repair',
	  component: () => import('../views/Repair.vue'),
	},
  {
    path: '/orderDetail',
    name: 'OrderDetail',
    component: () => import('../views/Ticket/detail.vue'),
  },
  {
    path: '/orderList',
    name: 'OrderList',
    component: () => import('../views/Ticket/OrderList.vue'),
    meta: {
      isTabbar: true,
    },
  },
  {
    path: '/announcementDetail',
    name: 'AnnouncementDetail',
    component: () => import('../views/Announcement/Detail.vue'),
  },
  {
    path: '/evaluation',
    name: 'Evaluation',
    component: () => import('../views/Evaluation.vue'),
  },
  {
    path: '/balance',
    name: 'Balance',
    component: () => import('../views/Balance.vue'),
    meta: {
      isTabbar: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/newbanche/',
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = '班车预约';
  next();
});

export default router;
